<div class="one" fxLayout="column" [formGroup]="matterLeasingForm">
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <!-- <mat-form-field appearance="outline" fxFlex="100" class="pr-1">
    <mat-label>Formula </mat-label>
    <textarea matInput formControlName="RENTFORMULA" matTooltip="{{(toolTipList)?toolTipList.RENTFORMULA?.HOVER:''}}"
    toolTipPostion ="above"></textarea>
    <div  *ngIf="testBool && toolTipList.RENTFORMULA" class="tooltip-wrap" ><input id="myInput" readonly disabled value="{{(toolTipList)?toolTipList.RENTFORMULA.COPYVALUE:''}}"><mat-icon (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.RENTFORMULA?.COPYVALUE:'')">file_copy</mat-icon></div>
  </mat-form-field> -->

    <mat-form-field appearance="outline" class="full-width pr-1" fxFlex="100">
      <mat-label>Formula</mat-label>

      <textarea
        matInput
        formControlName="RENTFORMULA"
        [matTooltip]="toolTipList?.RENTFORMULA?.HOVER || ''"
        matTooltipPosition="above"
        rows="4"
        (keydown.enter)="$event.stopImmediatePropagation()"
      ></textarea>
      @if (testBool && toolTipList.RENTFORMULA) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.RENTFORMULA.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.RENTFORMULA?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field appearance="outline" fxFlex="100" class="pr-1">
      <mat-label>Frequency</mat-label>
      <input
        matInput
        formControlName="RENTFORMULA"
        matTooltip="{{ toolTipList ? toolTipList.RENTFORMULA?.HOVER : '' }}"
        toolTipPostion="above"
      />
      @if (testBool && toolTipList.RENTREVIEWFREQUENCY) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.RENTREVIEWFREQUENCY.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.RENTREVIEWFREQUENCY?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Clause</mat-label>
      <input
        matInput
        formControlName="RENTREVIEWCLAUSE"
        matTooltip="{{ toolTipList ? toolTipList.RENTREVIEWCLAUSE?.HOVER : '' }}"
        toolTipPostion="above"
      />
      @if (testBool && toolTipList.RENTREVIEWCLAUSE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.RENTREVIEWCLAUSE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.RENTREVIEWCLAUSE?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Nature</mat-label>
      <input
        matInput
        formControlName="RENTREVIEWFREQUENCY"
        matTooltip="{{ toolTipList ? toolTipList.RENTREVIEWFREQUENCY?.HOVER : '' }}"
        toolTipPostion="above"
      />
      @if (testBool && toolTipList.RENTREVIEWFREQUENCY) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.RENTREVIEWFREQUENCY.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.RENTREVIEWFREQUENCY?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Fix Amount</mat-label>
      <input
        matInput
        formControlName="RENTREVIEWFIXEDAMOUNT"
        matTooltip="{{ toolTipList ? toolTipList.RENTREVIEWFIXEDAMOUNT?.HOVER : '' }}"
        toolTipPostion="above"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        style="text-align: right"
        class="sideText"
        [leadZero]="true"
      />
      @if (testBool && toolTipList.RENTREVIEWFIXEDAMOUNT) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.RENTREVIEWFIXEDAMOUNT.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.RENTREVIEWFIXEDAMOUNT?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Current CPI</mat-label>
      <input
        matInput
        formControlName="RENTREVIEWCURRENTCPI"
        matTooltip="{{ toolTipList ? toolTipList.RENTREVIEWCURRENTCPI?.HOVER : '' }}"
        toolTipPostion="above"
      />
      @if (testBool && toolTipList.RENTREVIEWCURRENTCPI) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.RENTREVIEWCURRENTCPI.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.RENTREVIEWCURRENTCPI?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Fixed Percent</mat-label>
      <input
        matInput
        formControlName="RENTREVIEWFIXEDPERCENT"
        matTooltip="{{ toolTipList ? toolTipList.RENTREVIEWFIXEDPERCENT?.HOVER : '' }}"
        toolTipPostion="above"
      />
      @if (testBool && toolTipList.RENTREVIEWFIXEDPERCENT) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.RENTREVIEWFIXEDPERCENT.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.RENTREVIEWFIXEDPERCENT?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Market Rent Percent</mat-label>
      <input
        matInput
        formControlName="RENTREVIEWMARKETRENTPERCENT"
        matTooltip="{{ toolTipList ? toolTipList.RENTREVIEWMARKETRENTPERCENT?.HOVER : '' }}"
        toolTipPostion="above"
      />
      @if (testBool && toolTipList.RENTREVIEWMARKETRENTPERCENT) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.RENTREVIEWMARKETRENTPERCENT.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.RENTREVIEWMARKETRENTPERCENT?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
</div>
